<app-error-message [errorMessage]="error"></app-error-message>
<app-spinner size="3x" *ngIf="!error"></app-spinner>
